import { Controller } from "@hotwired/stimulus";

// Drives the pricing cards: monthly/annual billing toggle and currency switch.
// Prices are server-rendered for the default currency; this controller only
// swaps in display-ready strings from the JSON embedded in each card.
export default class extends Controller {
  static targets = ["amount", "period", "switch", "currency"];
  static values = {
    currency: String,
    billing: { type: String, default: "monthly" },
  };

  // Marks the controller as wired so system specs can wait before clicking:
  // a toggle/select click before connect is a silent no-op (CI flakiness).
  connect() {
    this.element.setAttribute("data-pricing-ready", "");
  }

  toggleBilling() {
    this.billingValue = this.billingValue === "monthly" ? "annual" : "monthly";
    const annual = this.billingValue === "annual";
    this.switchTarget.setAttribute("aria-checked", annual.toString());
    this.switchTarget.classList.toggle("pricing-switch-on", annual);
    this.update();
  }

  changeCurrency() {
    this.currencyValue = this.currencyTarget.value;
    this.update();
  }

  update() {
    const currency = this.currencyValue;
    const annual = this.billingValue === "annual";

    this.amountTargets.forEach((el) => {
      const prices = JSON.parse(annual ? el.dataset.annual : el.dataset.monthly);
      el.textContent = prices[currency];
    });

    this.periodTargets.forEach((el) => {
      el.textContent = annual ? el.dataset.labelAnnual : el.dataset.labelMonthly;
    });
  }
}
